<template>
  <v-row wrap >
    <v-col>
      <v-list
        two-line
        v-if="invalidVehicles && invalidVehicles.length > 0"
      >
        <template v-for="(vehicle) in invalidVehicles">
          <v-list-group
            :sub-group="$vuetify.breakpoint.smAndUp"
            :no-action="$vuetify.breakpoint.smAndUp"
            :key="vehicle._id"
            :invalidObligations="countInvalidObligations(vehicle)"
            :value="false"
            :v-if="
              $store.state.auth.user.roles[0] !=
              $store.state.constants.roles.SECURITY
            "
          >
            <v-list-item slot="activator" >
              <v-list-item-action>
                <v-col>
                  <v-icon color="primary">commute</v-icon>
                  <v-badge overlap bordered color="error" v-if="invalidVehicles.length > 0">
                    <span slot="badge">{{
                      countInvalidObligations(vehicle) }}
                    </span>
                  </v-badge>
                  </v-col>
              </v-list-item-action>
              <v-list-item-content :key="vehicle._id" style="max-width: 220px;">
                <v-list-item-content style="max-width: 220px;">
                  <v-list-item-title>
                    {{ vehicle.description }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ `${resx.labels.domain}: ` }}
                    {{ vehicle.uniqueIdentifier }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <request-access-obligations-details
              :obligations="getDelayedVehicleObligations(vehicle)"
              @viewComment="$emit('viewComment', $event)"
            ></request-access-obligations-details>
            <v-divider></v-divider>
          </v-list-group>
        </template>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
"use strict";

import requestAccessObligationsDetails from "./request-access-obligations-details.view.vue";

export default {
  name: "requestAccessVehiclesDetails",
  components: {
    requestAccessObligationsDetails,
  },
  data() {
    return {
      value: [],
    };
  },
  methods: {
    countInvalidObligations(vehicle) {
      let delayedObligations = this.getDelayedVehicleObligations(vehicle);
      return delayedObligations ? delayedObligations.filter(
        o => o.status == this.$store.state.constants.OBLIGATIONS.STATUS.DELAYED
      ).length : null;
    },
    getDelayedVehicleObligations(vehicle) {
      const delayedVehiclesObligations = this.delayedVehicleObligations && this.delayedVehicleObligations.filter(o => o.referenceId == vehicle._id);
      return delayedVehiclesObligations; 
    },
  },
  props: {
    invalidVehicles: { type: Array },
    delayedVehicleObligations: { type: Array },
    personalProtectionItems: { type: Object },
    visit: { type: Object },
  }
};
</script>
